import { WORK_PREFERENCES, WorkPreference } from 'constants/collab-club';
import type { Artist } from 'types';

// The onboarding answers an admin can edit for a CollabClub artist.
export interface OnboardingValues {
  location: string | null;
  genres: string[];
  skills: string[];
  workPreference: WorkPreference | '';
}

// Prefill the onboarding fields from an artist's existing profile. Location / genres / skills
// are kept as-is even when they aren't in the curated option lists, so the admin can see the
// artist's real (possibly non-conforming) values when editing — the fields accept free text.
// workPreference stays constrained (it's a fixed toggle, not free text).
export const onboardingPrefill = (artist: Artist): OnboardingValues => ({
  location: artist.location || null,
  genres: artist.genres || [],
  skills: artist.skills || [],
  workPreference: (artist.workPreference && artist.workPreference in WORK_PREFERENCES
    ? (artist.workPreference as WorkPreference)
    : '') as WorkPreference | '',
});

// Build the admin profile patch from onboarding answers. Only includes fields with a value
// so we never wipe existing data; an empty object means there's nothing to persist.
export const buildProfilePatch = (values: OnboardingValues): Record<string, unknown> => {
  const patch: Record<string, unknown> = {};
  if (values.location) patch.location = values.location;
  if (values.genres.length) patch.genres = values.genres;
  if (values.skills.length) patch.skills = values.skills;
  if (values.workPreference) patch.workPreference = values.workPreference;
  return patch;
};
